import { useDeviceSelect } from '@modules/reception/device-select'

export const useBandReader = () => useDeviceSelect('band_reader_id')
